// EM: Location configuration models for hierarchical structure
export class LocationConfig {
  public id = -1;
  protected items: LocationConfigItem[] = [];

  public static FromRawJSON(data: any): LocationConfig {
    return Object.assign(new LocationConfig(), {
      id: data.id,
      items: data.items.map((item: any) => Object.assign(new LocationConfigItem(), item)),
    });
  }

  public static merge(child_conf: LocationConfig, parent_conf: LocationConfig) {
    return Object.assign(new LocationConfig(), {
      id: child_conf.id,
      items: [...child_conf.items, ...parent_conf.items]
        .filter(
          (val, index, array) => index === array.findIndex((item) => item.letter === val.letter)
        )
        .sort((a, b) => a.letter.localeCompare(b.letter)),
    });
  }

  public get(letter: LocationLetter): LocationConfigItem | undefined {
    return this.items.find((item: LocationConfigItem) => item.letter === letter);
  }
}

export class LocationConfigItem {
  public letter!: LocationLetter;
  public name!: string;
  public optional!: boolean;
  public active!: boolean;
  public asset!: boolean;
  public locationConfigId = -1;
}

export class LocationConfigMapping {
  public objectId!: number;
  public locationConfigId!: number;
  public referenceLetter!: string;
}

export class LocationConfigCollection {
  configs: LocationConfig[] = [];
  mappings: LocationConfigMapping[] = [];

  get defaultConfigId(): number {
    const defaultMapping = this.mappings.find((item) => item.objectId === null);
    if (!defaultMapping) return -1;
    return defaultMapping.locationConfigId;
  }

  public static FromRawJSON(data: any): LocationConfigCollection {
    return Object.assign(new LocationConfigCollection(), {
      configs: data.configs.map((config: any) => LocationConfig.FromRawJSON(config)),
      mappings: data.mappings.map((mapping: any) =>
        Object.assign(new LocationConfigMapping(), mapping)
      ),
    });
  }

  public getConfig(objectId: number, parentConfig: LocationConfig | null): LocationConfig | null {
    const mapping = this.mappings.find((item) => item.objectId === objectId);
    if (!mapping && !parentConfig)
      return this.configs.find((item) => item.id === this.defaultConfigId) || null;
    if (!mapping && !!parentConfig) return parentConfig;
    if (!!mapping && !!parentConfig) {
      const config = this.configs.find((item) => item.id === mapping.locationConfigId);
      if (!config) return parentConfig;
      return LocationConfig.merge(config, parentConfig);
    }
    return null;
  }
}

export type LocationLetter = 'a' | 'b' | 'c' | 'd' | 'e' | 'f' | 'g' | 'h' | 'i' | 'j';

export function nextLetter(letter: LocationLetter): LocationLetter | null {
  switch (letter) {
    case 'a':
      return 'b';
    case 'b':
      return 'c';
    case 'c':
      return 'd';
    case 'd':
      return 'e';
    case 'e':
      return 'f';
    case 'f':
      return 'g';
    case 'g':
      return 'h';
    case 'h':
      return 'i';
    case 'i':
      return 'j';
    case 'j':
      return null;
    default:
      return null;
  }
}
